'use strict';

module.exports = function pipe(fn) {
  return fn(this);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/pipe.js
// module id = 1259
// module chunks = 2